module.exports = __webpack_public_path__ + "static/media/r2-5.f79ce6f6.jpg";